
import {Component, Prop, Vue} from 'vue-property-decorator';
import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'catalog-product-media',
  components: {
    ...ServiceContainer().getComponents(),
    Swiper,
    Navigation,
  },
})

export default class extends Vue {
  @Prop({default: []}) private readonly mediaGallery: Array<Array<object>>;
  @Prop() private readonly productData: object;

  private showFullScreen: boolean = false;

  private mediaSwiper: Swiper | null = null;
  private thumbsSwiper: Swiper | null = null;

  private activeMediaGallery: Array<object> = [];

  private defaultPlaceholder: string = '/area/web/default/assets/images/media-gallery-placeholder.png';

  private imageSrc(value: string, size: number): string {
    if (typeof value === 'undefined' || value === null || value === undefined) {
      return this.defaultPlaceholder;
    }

    return `${this.$solarCdnBaseUrl}/cdn/resize-extended/rs:fill/w:${size}/extend:true/bl:10.0/q:40/path/media/catalog/product${value}`;
  }

  private imageDataSrc(value: string, size: number): string {
    return `${this.$solarCdnBaseUrl}/cdn/resize-extended/rs:fill/w:${size}/extend:true/path/media/catalog/product${value} 1x,
    ${this.$solarCdnBaseUrl}/cdn/resize-extended/rs:fill/w:${size * 2}/extend:true/path/media/catalog/product${value} 2x`;
  }

  private created(): void {
    this.$nextTick(() => {
      this.mediaSwiper = new Swiper(`.product__media-container .--images .swiper`, {
        slidesPerView: 1,
        roundLengths: true,
      });

      this.thumbsSwiper = new Swiper(`.product__media-container .--thumbnails .swiper`, {
        modules: [Navigation],
        slidesPerView: 4,
        spaceBetween: 10,
        roundLengths: true,
        direction: 'vertical',
        navigation: {
          nextEl: `.product__media-container .--thumbnails .swiper__button.--next`,
          prevEl: `.product__media-container .--thumbnails .swiper__button.--prev`,
        },
      });

      this.mediaSwiper?.on('slideChange', () => {
        this.$eventBus.$emit('parseActiveIndex', this.mediaSwiper?.activeIndex);
      });
    });

    this.activeMediaGallery = this.mediaGallery.flat();

    this.$eventBus.$on('updateProductImage', (index: number) => {
      this.activeMediaGallery = this.mediaGallery[index];
      this.$nextTick(() => {
        this.mediaSwiper?.update();
        this.thumbsSwiper?.update();
        const images = document.querySelectorAll('.product__media-container .swiper-slide img');
        images.forEach((image) => {
          image.classList.add('lazyload');
        });
      });
    });

    this.$eventBus.$on('parseFullscreenActiveIndex', (index: number) => {
      this.slideTo(index);
    });
  }

  private slideTo(index: number): void {
    this.mediaSwiper.slideTo(index);
  }

  private closeFullscreen(): void {
    this.showFullScreen = false;
    document.body.classList.remove('no-scroll');
  }

  private showFullscreen(): void {
    this.showFullScreen = true;
    document.body.classList.add('no-scroll');
  }

  private mounted(): void {
    window.addEventListener('keyup', (e) => {
      if (e.key === 'Escape') {
        this.closeFullscreen();
      }
    });

    const placeholder = document.getElementById('mediaGalleryPlaceholder');
    if (placeholder) {
      placeholder.style.visibility = 'hidden';
    }
  }
}
